import Analytics from '@web/services/Analytics/Analytics'

function platform (): string {
  return window.innerWidth >= 1024 ? 'desktop' : 'mobile'
}

export function remindersMainToggleClicked (payload: { mainToggleState: 'on' | 'off' }): void {
  Analytics.send({ action: 'reminders_main_toggle_clicked', platform: platform(), main_toggle_state: payload.mainToggleState })
}

export function browserNotificationsPermissionRequested (): void {
  Analytics.send({ action: 'browser_notifications_permission_requested', platform: platform() })
}

export function browserNotificationsPermissionResult (payload: { permissionStatus: string }): void {
  Analytics.send({ action: 'browser_notifications_permission_result', platform: platform(), permission_status: payload.permissionStatus })
}

export function reminderCreateClicked (payload: { remindersCount: number }): void {
  Analytics.send({ action: 'reminder_create_clicked', platform: platform(), reminders_count: String(payload.remindersCount) })
}

export function reminderCreated (payload: { reminderId: number; selectedDays: number[]; time: string; remindersCount: number }): void {
  Analytics.send({
    action: 'reminder_created',
    platform: platform(),
    reminder_id: String(payload.reminderId),
    days_count: String(payload.selectedDays.length),
    selected_days: payload.selectedDays.join(','),
    time: payload.time,
    reminders_count: String(payload.remindersCount)
  })
}

export function reminderDeleted (payload: { reminderId: number; remindersCount: number }): void {
  Analytics.send({ action: 'reminder_deleted', platform: platform(), reminder_id: String(payload.reminderId), reminders_count: String(payload.remindersCount) })
}

export function reminderToggleClicked (payload: { reminderId: number; reminderToggleState: 'on' | 'off' }): void {
  Analytics.send({ action: 'reminder_toggle_clicked', platform: platform(), reminder_id: String(payload.reminderId), reminder_toggle_state: payload.reminderToggleState })
}

export function remindersMainToggleDisabled (payload: { remindersCount: number }): void {
  Analytics.send({ action: 'reminders_main_toggle_disabled', platform: platform(), reminders_count: String(payload.remindersCount) })
}
